var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCompose = function SvgCompose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.575,10.692l2.382,2.262L9.98,13.519C9.98,13.519,10.575,10.692,10.575,10.692z M19.507,6.73l-5.359,5.092L11.766,9.56 l5.359-5.091c0.658-0.625,1.724-0.625,2.382,0C20.164,5.093,20.164,6.106,19.507,6.73L19.507,6.73z M17.475,20.001H5.684 C4.755,20.001,4,19.283,4,18.4V7.199c0-0.882,0.756-1.6,1.684-1.6h5.895v1.6H5.684V18.4h11.79V11.2h1.684V18.4 C19.159,19.283,18.403,20.001,17.475,20.001z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compose.a7c84d01.svg";
export { ForwardRef as ReactComponent };